import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export const supportService = {
    async sendMessage(payload) {
        return apiClient.postPublic(ENDPOINTS.SUPPORT.SEND, payload);
    },
};
